import React from "react";
import { _cs } from "@togglecorp/fujs";
import { Translation } from "react-i18next";

import Icon from "#rscg/Icon";
import CustomNavLink from "#components/Common/CustomNavLink";

import styles from "./styles.module.scss";

export interface MenuItemProps {
  className?: string;
  title: string;
  link: string;
  iconName?: string;
  disabled?: boolean;
  titleClassName?: string;
  id?: string;
  onPreload?: () => void;
}

export default class MenuItem extends React.PureComponent<MenuItemProps> {
  private getTitle = (val: string) => (
    <Translation>{(t) => <span>{t(val)}</span>}</Translation>
  );
  private getLinkClassName = () => {
    const { className, disabled } = this.props;
    return _cs(styles.menuItem, className, disabled && styles.disabled);
  };

  public render() {
    const { title, link, iconName, titleClassName, id, disabled, onPreload } =
      this.props;

    return (
      <CustomNavLink
        to={link}
        disabled={disabled}
        className={this.getLinkClassName()}
        id={id}
        onFocus={onPreload}
        onMouseEnter={onPreload}
      >
        {iconName && <Icon className={styles.icon} name={iconName} />}
        <div className={_cs(titleClassName, styles.title)}>
          {this.getTitle(title)}
        </div>
      </CustomNavLink>
    );
  }
}
